var _style, _path, _path2, _path3, _polygon, _polygon2, _polygon3, _path4, _path5, _line, _path6, _path7, _ellipse, _path8, _path9, _ellipse2, _line2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _path17, _circle2, _circle3, _path18, _path19, _line3, _g, _ellipse3, _path20, _polyline, _line4, _line5, _line6, _path21, _path22, _path23, _path24, _path25, _path26, _g2, _circle4, _path27, _line7, _path28, _circle5, _ellipse4, _path29, _path30, _circle6, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path38, _polyline2, _ellipse5, _ellipse6, _line8, _line9, _line10, _path39, _ellipse7, _circle7, _circle8, _circle9, _path40, _path41, _path42, _path43, _g3, _circle10, _path44, _path45, _path46, _line11, _path47, _circle11, _circle12, _path48, _path49, _circle13, _path50, _path51;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 280 195.4",
    style: {
      enableBackground: "new 0 0 280 195.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E5E5E5;}\n\t.st1{fill:#D1DAFA;stroke:#3A3836;stroke-miterlimit:10;}\n\t.st2{opacity:0.7;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st3{opacity:0.7;}\n\t.st4{fill:url(#SVGID_00000121978341686182880800000008519264336821667457_);}\n\t.st5{fill:none;stroke:#3A3836;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#262626;}\n\t.st7{fill:url(#SVGID_00000139998395768939933370000011294410777483766180_);}\n\t.st8{fill:url(#SVGID_00000011008833174303896490000011789277176055497918_);}\n\t.st9{fill:url(#SVGID_00000041273164710900695730000018317767321687861907_);}\n\t.st10{fill:url(#SVGID_00000111151337754746666760000006074287440754831029_);}\n\t.st11{fill:#FF6C37;}\n\t.st12{fill:url(#SVGID_00000079460523206162281690000015152312992129009834_);}\n\t.st13{fill:url(#SVGID_00000124151752163473205720000011265324540070732930_);}\n\t.st14{fill:none;stroke:#3A3836;stroke-width:1.0024;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0098;}\n\t.st15{fill:url(#SVGID_00000108305304435803068900000011470771010307522444_);}\n\t.st16{fill:url(#SVGID_00000124153808156547186420000002128815519598738603_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.1,178.1H261c0.3,3.4-0.5,6.8-4.6,7.8c-7.2,1.9-9.9-5-10.7-7.8h-12.7c-0.5,2.3-2.6,10.1-9.4,8.9 c-4.4-0.8-5.6-4.1-5.7-6.8c-0.7,0.9-1.2,2.1-1.2,3.4v0c0,3,2.5,5.5,5.5,5.5h39.8c3,0,5.5-2.5,5.5-5.5v0 C267.6,180.6,265.1,178.1,262.1,178.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.9,178.1h-12.1l-1.3,7.7c0,0,2.3,1.3-6.9,0.9c-7.1-0.4-7.5-6-7.3-8.6h-4.7c-0.1,3.8-1.2,9-7.1,8.5 c-3.2-0.3-4.9-1.3-5.9-2.7c0.2,2.9,2.6,5.2,5.5,5.2h39.8c3,0,5.5-2.5,5.5-5.5v0C192.4,180.6,189.9,178.1,186.9,178.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.2,178.1h-9.9v2c0,0-1,7.9-6.9,7c-5.9-0.9-7-4.8-7-4.8l-0.9-4.3h-7.3c0,2.4-0.4,8.3-6.2,9.2 c-3.6,0.5-5.8-1-7.1-2.6c0.5,2.5,2.7,4.4,5.4,4.4h39.8c3,0,5.5-2.5,5.5-5.5v0C93.7,180.6,91.2,178.1,88.2,178.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000114040321618868224560000012891422284224363189_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "114.5,109.4 109.7,109.4 107.7,104.4 112.6,104.4  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "118.5,119.4 113.7,119.4 111.7,114.4 116.6,114.4  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "122.5,129.4 117.7,129.4 115.7,124.4 120.6,124.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.36,
    y1: 5064.895,
    x2: 147.45,
    y2: 5064.895,
    gradientTransform: "matrix(1 0 0 1 0 -4946.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FE7304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FC7C0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F88B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F3A125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#ECBD39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBC03B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.9,121.2l-2.5-6.7h19.8l3.3,8.2l-8.4-3.7c0,0-4.4-4.3-9.1-1.9L126.9,121.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016074268444183851330000015034069682432678836_",
    gradientUnits: "userSpaceOnUse",
    x1: -4719.915,
    y1: 636.049,
    x2: -4711.4253,
    y2: 636.049,
    gradientTransform: "matrix(-0.14 -0.9901 -0.9901 0.14 202.8529 -4724.2837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FE7304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FC7C0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F88B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F3A125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#ECBD39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBC03B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016074268444183851330000015034069682432678836_)"
    },
    d: "M235.4,25.2c0,0,1.5,5.8-5.2,9.3 l-0.2-4.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235.3,24.8c0,0,2.9,5.2-5.4,10l-0.3-4.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 225.1,
    y1: 29.6,
    x2: 171.5,
    y2: 90.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233.8,25.9L233.8,25.9C233.8,26.1,233.8,26,233.8,25.9C233.9,26,233.9,26,233.8,25.9 C233.9,25.8,233.8,25.9,233.8,25.9z M236.1,24.6c0.1-0.1,0.3-0.1,0.1,0S236.2,24.6,236.1,24.6C236,24.7,235.9,24.6,236.1,24.6z  M230.6,29.9c-0.1,0-0.1,0-0.1,0.1l0,0L230.6,29.9L230.6,29.9z M231.2,28.2C231.2,28.2,231.1,28.2,231.2,28.2 C231.2,28.2,231.2,28.2,231.2,28.2C231.3,28.2,231.2,28.3,231.2,28.2z M231.5,28L231.5,28L231.5,28 C231.5,27.9,231.5,27.9,231.5,28C231.6,27.9,231.5,28,231.5,28L231.5,28z M232.2,27.5L232.2,27.5L232.2,27.5 C232.2,27.5,232.2,27.5,232.2,27.5z M233.9,25.8c-0.1,0-0.1-0.1-0.1-0.1C233.8,25.7,233.9,25.7,233.9,25.8L233.9,25.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102535606547173365590000007375803258583064449_",
    gradientUnits: "userSpaceOnUse",
    x1: 838.0433,
    y1: 4582.5552,
    x2: 855.2533,
    y2: 4582.5552,
    gradientTransform: "matrix(0.98 0.19 -0.19 0.98 273.05 -4631.3799)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FE7304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FC7C0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F88B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F3A125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#ECBD39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBC03B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102535606547173365590000007375803258583064449_)"
    },
    d: "M241.6,12.2c0-0.4-0.9-0.2-0.9-0.6l0,0 l-0.6-0.1c-3.3-0.2-6.5,1-8.8,3.3l-3.3,3l-5.2,5.4l2.5,2.9l4.2,4.3l6.4-5.9l3.9-3.8C242.1,18.4,241.4,14.9,241.6,12.2z  M235.7,20.1c-0.8,0.8-1.8,1.2-2.6,0.4c-0.8-1-0.9-2.4-0.1-3.4c0.8-0.8,2.3-0.3,3.1,0.5S236.5,19.4,235.7,20.1L235.7,20.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M241.4,12.1c-0.2-0.1-0.5-0.1-0.7-0.2c-3.3-0.8-6.9,0.1-9.4,2.5l-3.2,3l-5.6,5.2l3.5,3.8l3.5,3.9l5.9-5.5 l3-2.9c2.3-2.2,3.5-5.3,3.2-8.4C241.6,13,241.3,12,241.4,12.1L241.4,12.1z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.193 -0.9812 0.9812 0.193 170.9389 244.9682)",
    className: "st5",
    cx: 234.4,
    cy: 18.6,
    rx: 2.1,
    ry: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023993076764663637160000017517007185672652472_",
    gradientUnits: "userSpaceOnUse",
    x1: 833.3433,
    y1: 4583.1279,
    x2: 841.8333,
    y2: 4583.1279,
    gradientTransform: "matrix(0.98 0.19 -0.19 0.98 273.05 -4631.3799)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FE7304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FC7C0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F88B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F3A125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#ECBD39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBC03B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023993076764663637160000017517007185672652472_)"
    },
    d: "M227.8,16.9c0,0-5.7-1.8-9.6,4.6 l4.3,0.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.4,28.2l-0.9,1.2c-0.1,0.2-0.4,0.3-0.6,0.2l-0.1-0.1l-2.6-3.1c-0.2-0.2-0.2-0.4,0-0.6c0,0,0,0,0,0 l0.1-0.1l1.4-0.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M228.3,17c0,0-5.1-3.1-10.3,4.9l4.8,0.6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.193 -0.9812 0.9812 0.193 170.9389 244.9682)",
    className: "st5",
    cx: 234.4,
    cy: 18.6,
    rx: 2.1,
    ry: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 223.4,
    y1: 27,
    x2: 135.5,
    y2: 100
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M184.3,124.8c2.9-2.7,4.9-6.2,5.9-10.1c2.5-10.4-3.9-20.8-14.3-23.3c-10.4-2.5-20.8,3.9-23.3,14.3 c-1.7,7.2,0.9,14.9,6.7,19.5l2.2,1.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M156.9,123.2c0,0-9.2,2.3-19.8-5.7c-2.7-2.1-6.7-1.6-8.7,1.1c0,0,0,0,0,0c-0.1,0.1-0.2,0.2-0.2,0.3l-0.1,0.1 c-1.7,2.5-1.3,5.9,0.8,8c4.1,4,13.8,9.7,25.5,10.2v11.8l-2-0.1l0,0c-6.5,0-11.7,5.3-11.7,11.7v19.9c0,3.8,3.1,5.9,6.9,5.9l0,0 c3.8,0,6.9-2.1,6.9-5.9v-14.5c0-2,1.6-3.6,3.6-3.6h21.6c2.6,0,6.5,0.5,6.7-3.7l0,0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.8,99.6c5.9,2.2,9.2,8.4,7.8,14.6c-0.9,3.6-3.9,6.7-7,8.3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M166.7,124.8h19c3.5,0,6.4,2.8,6.4,6.4v21.4c0,3.5-2.8,6.4-6.4,6.4h-19c-3.5,0-6.4-2.8-6.4-6.4v-21.4 C160.3,127.6,163.1,124.8,166.7,124.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154.5,144.6c0,0,1.9,0.9,5.8-3.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154.4,149.2c0,0,2.7,0.7,5.8-2.2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M153.5,123.5c0,0,6.8,2.8,6.9,7.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 174,
    cy: 112.2,
    r: 2.9
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M168.9,124.8v7.4c0,2.8,2.2,5,5,5h17.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021823438960231431780000013415185977666533051_",
    gradientUnits: "userSpaceOnUse",
    x1: -1587.14,
    y1: 5088.5298,
    x2: -1584.13,
    y2: 5088.5298,
    gradientTransform: "matrix(-1 0 0 1 -1408.77 -4946.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FE7304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FC7C0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F88B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F3A125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#ECBD39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBC03B"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000021823438960231431780000013415185977666533051_)"
    },
    cx: 176.9,
    cy: 142.3,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117661050719049484350000004643922129868666804_",
    gradientUnits: "userSpaceOnUse",
    x1: -1592.8,
    y1: 5088.8398,
    x2: -1589.28,
    y2: 5088.8398,
    gradientTransform: "matrix(-1 0 0 1 -1408.77 -4946.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FE7304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FC7C0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F88B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F3A125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#ECBD39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBC03B"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000117661050719049484350000004643922129868666804_)"
    },
    cx: 182.3,
    cy: 142.6,
    r: 1.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 176.9,
    cy: 142.4,
    r: 1.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 182.2,
    cy: 142.4,
    r: 1.8
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M191.5,144.4h-4.1c-0.8,0-1.4-0.8-1.4-1.8l0,0c-0.1-0.9,0.5-1.7,1.4-1.8h4.1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M191.5,147.7h-22.1c-0.9,0.1-1.5,0.9-1.4,1.8l0,0c0,1,0.6,1.8,1.4,1.8h22.1"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 184.9,
    y1: 92.9,
    x2: 183.4,
    y2: 94.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6497 -0.7602 0.7602 0.6497 -3.7234 173.8155)",
    className: "st11",
    cx: 186.7,
    cy: 90.9,
    rx: 2.7,
    ry: 2.7
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6497 -0.7602 0.7602 0.6497 -3.5343 173.7662)",
    className: "st5",
    cx: 186.8,
    cy: 90.7,
    rx: 2.7,
    ry: 2.7
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M159.6,167.8v12.9c0,3.8,3.1,5.9,6.9,5.9c0.6,0,2.2-0.1,2.8-0.2"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "154.1,143.4 120.3,143.5 103.9,100.3 154.3,100.3  "
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 130.3,
    y1: 143.5,
    x2: 113.9,
    y2: 100.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 199.5,
    y1: 143.5,
    x2: 192,
    y2: 143.6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 188.6,
    y1: 119.5,
    x2: 199.7,
    y2: 143.4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M183.4,168.1c0,0-10.3,3.1-10,18.8h-4c0.3-15.8-10-18.8-10-18.8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M222,132.8l-4.1,45.6c-0.4,5.9,2.6,8.8,7,8.8l0,0c4.3-0.1,6.6-2.5,7.7-7.8l3.8-18.4l5.9-0.9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M254.9,150l5.7,27.6c0.3,1.4,0.3,2.8-0.1,4.2c-0.7,2.7-3.2,4.5-6,4.4l0,0c-4.1,0-6.6-2-8.3-7.2l-5.8-18.1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M236.7,116c-10.6-1-18.4-10.4-17.4-21c1-10.6,10.4-18.4,21-17.4c10.6,1,18.4,10.4,17.4,21 c-0.2,2.6-1,5.1-2.3,7.4l-0.6,1c0,0-3.1,5.7-11.7,8.3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.7,115.4h19c3.5,0,6.4,2.8,6.4,6.3v21.4c0,3.5-2.8,6.4-6.4,6.4h-19c-3.5,0-6.4-2.8-6.4-6.4v-21.4 C233.4,118.2,236.2,115.4,239.7,115.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M260.6,149.3c0,0,0.7,6.7-4.2,7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 237.2,
    cy: 72.3,
    r: 2.7
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 237.2,
    cy: 72.3,
    r: 2.7
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M221.4,88.3c3.3,1,6.1,3.4,7.4,6.6c2.7,5.8,2.1,12.3-3.2,15.6"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 237.3,
    y1: 75.1,
    x2: 237.6,
    y2: 77.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M242.2,115.8v7.4c0,2.8,2.2,5,5,5h17.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181084902161500815360000017243274634639685016_",
    gradientUnits: "userSpaceOnUse",
    x1: -3240.01,
    y1: 5079.54,
    x2: -3237,
    y2: 5079.54,
    gradientTransform: "matrix(-1 0 0 1 -2988.3 -4946.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FE7304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FC7C0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F88B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F3A125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#ECBD39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBC03B"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000181084902161500815360000017243274634639685016_)"
    },
    cx: 250.2,
    cy: 133.3,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003103880333717607770000004806541596526155692_",
    gradientUnits: "userSpaceOnUse",
    x1: -3245.6699,
    y1: 5079.9077,
    x2: -3242.1494,
    y2: 5079.9077,
    gradientTransform: "matrix(-1 0 0 1 -2988.1067 -4946.2744)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FE7304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FC7C0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F88B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F3A125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#ECBD39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBC03B"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000003103880333717607770000004806541596526155692_)"
    },
    cx: 255.6,
    cy: 133.6,
    r: 1.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 250.2,
    cy: 133.4,
    r: 1.8
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3163 -0.9487 0.9487 0.3163 48.1633 333.6842)",
    className: "st5",
    cx: 255.6,
    cy: 133.4,
    rx: 1.8,
    ry: 1.8
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M264.8,131.7h-4.1c-0.8,0-1.4,0.8-1.4,1.8l0,0c-0.1,0.9,0.5,1.7,1.4,1.8h4.1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M264.8,138.7h-22.1c-0.8,0-1.4,0.8-1.4,1.8l0,0c-0.1,0.9,0.5,1.7,1.4,1.8h22.1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 239.4,
    cy: 97.8,
    r: 2.9
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M224.9,111c0,0-23.3,20.9-24.7,36.6c-0.2,2.9,1.9,5.5,4.9,5.9l0,0c2.7,0.3,4.2-0.8,8.2-7.4 c1-1.7,7.5-12.4,8.7-13.4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M222,134.4c0,0,5.6,5.7,11.2-3.2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M221.3,139.3c0,0,5.8,5.4,11.9-1.4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110.8,119.8l-5.7,4.7c0,0-18.1-2.4-17.9,15.3c0,0-8.7-2.8-10.6,4.7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.1,166.2c0,0-14.2-11.2-25.9-0.5c0,0-4.6,3.5-6.3,11.2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M250.5,111.8c0,0,4.2,0.6,5.2,3.3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M231.5,114.9c1.6,1.5,2.3,3.7,2,5.8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "114.5,109.4 109.7,109.4 107.7,104.4 112.6,104.4  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "118.5,119.4 113.7,119.4 111.7,114.4 116.6,114.4  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "122.5,129.4 117.7,129.4 115.7,124.4 120.6,124.4  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "145.3,106.2 121.2,106.2 120.4,104 144.4,104  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "147.3,111.2 123.2,111.2 122.4,109 146.4,109  "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M150.6,101c-0.5-0.5,2.1,4.7,2.1,4.7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "147.4,122.7 144.1,114.4 124.3,114.4 126.8,121.1  "
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9475 -0.3196 0.3196 0.9475 -37.4796 50.2483)",
    className: "st5",
    cx: 134.3,
    cy: 139.3,
    rx: 1.3,
    ry: 1.6
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9477 -0.3192 0.3192 0.9477 -37.18 51.9322)",
    className: "st14",
    cx: 139.8,
    cy: 139.4,
    rx: 1.3,
    ry: 1.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 119.8,
    y1: 134.6,
    x2: 124.4,
    y2: 134.6
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 120.7,
    y1: 136.6,
    x2: 125.2,
    y2: 136.6
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 121.5,
    y1: 138.6,
    x2: 126,
    y2: 138.6
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.6,155.5c-2.9,2.9-8,3.8-9.7,2.1s-0.6-6.5,2.4-9.4s7.3-3.6,9-1.9S21.5,152.5,18.6,155.5z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8067 -0.591 0.591 0.8067 -26.1899 93.461)",
    className: "st5",
    cx: 129.8,
    cy: 86.8,
    rx: 6.1,
    ry: 3.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 87.6,
    cy: 47.4,
    r: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 269.6,
    cy: 80.7,
    r: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 8.4,
    cy: 104.7,
    r: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.4,124.2c-5.6-5.5-10.2-11.9-13.7-19c-1.5-3-0.5-6.7,2.4-8.4l0,0c3.1-1.9,6.7-0.3,8.6,2.8 c2.8,4.6,6.3,8.9,10.1,12.7"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.4,150.1v30c0,4.1,3.3,7.4,7.4,7.4l0,0c4.1,0,7.4-3.3,7.4-7.4c0,0,0,0,0,0l0,0l0.8-19.1 c0-1.5,1.7-1.4,2.5-1.4l0,0c0.8,0,1.5,0.6,1.5,1.4l2.8,18.4c0.6,4.7,3.5,7.8,7.7,7.8l0,0c4.4,0,7-4.4,7-8.8l-2.8-49.3 c9.4-6.7,15.9-16.5,19.6-23.9c1.5-3,0.5-6.7-2.4-8.4l0,0c-4.2-2.1-7.5,0.6-9.4,3.6c-9.6,15.7-15.9,13.8-15.9,13.8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M42.1,115.2l-0.9-0.7c-8-7.1-8.7-19.2-1.7-27.2s19.2-8.7,27.2-1.7s8.7,19.2,1.7,27.2c-1.7,2-3.9,3.6-6.2,4.7 l-0.6,0.3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M37.6,115.4h19c3.5,0,6.3,2.8,6.3,6.3v21.4c0,3.5-2.8,6.4-6.3,6.4h-19c-3.5,0-6.3-2.8-6.3-6.4v-21.4 C31.3,118.3,34.1,115.4,37.6,115.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 41.8,
    cy: 78.8,
    r: 2.7
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 41.8,
    cy: 78.8,
    r: 2.7
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M72,106c-6.2-0.7-10.4-5.9-10.4-12.3c-0.1-3.5,1.3-6.8,3.9-9.1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M75.6,129.1c0,0-3.5,10.5-12.6,8.5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76,136.7c0,0-3.9,8.2-13,6.2"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 43,
    y1: 81.3,
    x2: 44.3,
    y2: 83.4
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.1,115.8v7.4c0,2.8-2.2,5-5,5H31.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026849686526596718420000003026321024693523594_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.61,
    y1: 5079.5898,
    x2: 47.62,
    y2: 5079.5898,
    gradientTransform: "matrix(1 0 0 1 0 -4946.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FE7304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FC7C0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F88B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F3A125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#ECBD39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBC03B"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000026849686526596718420000003026321024693523594_)"
    },
    cx: 46.1,
    cy: 133.4,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108295887746641758880000004427412434439871898_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.94,
    y1: 5079.8999,
    x2: 42.46,
    y2: 5079.8999,
    gradientTransform: "matrix(1 0 0 1 0 -4946.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FE7304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FC7C0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F88B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F3A125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#ECBD39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBC03B"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000108295887746641758880000004427412434439871898_)"
    },
    cx: 40.7,
    cy: 133.7,
    r: 1.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 46.1,
    cy: 133.5,
    r: 1.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 40.8,
    cy: 133.5,
    r: 1.8
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.5,131.8h4.1c0.8,0,1.4,0.8,1.4,1.8l0,0c0.1,0.9-0.5,1.7-1.4,1.8h-4.1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.5,138.8h22.1c0.8,0,1.4,0.8,1.4,1.8l0,0c0.1,0.9-0.5,1.7-1.4,1.8H31.5"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 54.8,
    cy: 103.4,
    r: 2.9
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.9,121.1c0,0,0.4-1.9,4.6-6.8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M157.7,162.4h28.2c1.5,0,2.7,1.2,2.7,2.7v0c0,1.5-1.2,2.7-2.7,2.7h-28.2c-1.5,0-2.7-1.2-2.7-2.7v0 C155,163.6,156.2,162.4,157.7,162.4z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalc);
export default __webpack_public_path__ + "static/media/calc.3385ecfa6f9284b1df99096f6ab456fe.svg";
export { ForwardRef as ReactComponent };